// (function () {
//   'use strict';

//   function initBoxGallery(root) {
//     if (!root || root.dataset.boxGalleryInitialized === 'true') return;
//     if (!window.Swiper) return;

//     var mainEl = root.querySelector('[data-box-gallery-main]');
//     var thumbsEl = root.querySelector('[data-box-gallery-thumbs]');
//     var prevBtn = root.querySelector('[data-box-gallery-prev]');
//     var nextBtn = root.querySelector('[data-box-gallery-next]');

//     if (!mainEl) return;

//     root.dataset.boxGalleryInitialized = 'true';

//     var thumbsSwiper = null;

//     if (thumbsEl) {
//       thumbsSwiper = new Swiper(thumbsEl, {
//         slidesPerView: 6.5,
//         spaceBetween: 10,
//         watchSlidesProgress: true,

//         breakpoints: {
//           0: {
//             slidesPerView: 4.5,
//             spaceBetween: 8
//           },
//           750: {
//             slidesPerView: 6.5,
//             spaceBetween: 10
//           }
//         }
//       });
//     }

//     var mainSwiper = new Swiper(mainEl, {
//       slidesPerView: 'auto',
//       centeredSlides: false,
//       spaceBetween: 20,
//       initialSlide: 0,
//       speed: 450,
//       allowTouchMove: true,
//       thumbs: thumbsSwiper
//         ? {
//             swiper: thumbsSwiper
//           }
//         : undefined,
//       navigation: {
//         prevEl: prevBtn,
//         nextEl: nextBtn
//       },
//       breakpoints: {
//         0: {
//           spaceBetween: 10
//         },
//         750: {
//           spaceBetween: 20
//         }
//       }
//     });
//     mainSwiper.update();
//   }

//   function initAll(scope) {
//     (scope || document)
//       .querySelectorAll('.box-gallery')
//       .forEach(initBoxGallery);
//   }

//   document.addEventListener('DOMContentLoaded', function () {
//     initAll();
//   });

//   document.addEventListener('shopify:section:load', function (event) {
//     initAll(event.target);
//   });

// })();

/* =========================
   THUMB SLIDER
========================= */

(function () {
  'use strict';

  function initBoxGallery(root) {
    if (!root || root.dataset.boxGalleryInitialized === 'true') return;
    if (!window.Swiper) return;

    var mainEl = root.querySelector('[data-box-gallery-main]');
    var thumbsEl = root.querySelector('[data-box-gallery-thumbs]');
    var prevBtn = root.querySelector('[data-box-gallery-prev]');
    var nextBtn = root.querySelector('[data-box-gallery-next]');

    if (!mainEl) return;

    root.dataset.boxGalleryInitialized = 'true';

    var thumbsSwiper = null;
    var mainSwiper = null;

    /* =========================
       DEVICE
    ========================= */

    function isMobile() {
      return window.innerWidth <= 989;
    }

    /* =========================
       THUMB SLIDER
    ========================= */

    function initThumbs() {
      if (!thumbsEl) return;

      thumbsSwiper = new Swiper(thumbsEl, {
        /*
         * MOBILE
         *
         * Show complete thumbnails only.
         * Do not use fractional slidesPerView.
         */

        slidesPerView: 4,
        spaceBetween: 8,

        watchSlidesProgress: true,
        freeMode: false,

        direction: 'horizontal',

        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,

        breakpoints: {
          /*
           * MOBILE
           */
          0: {
            slidesPerView: 4.8,
            spaceBetween: 8,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0
          },

          /*
           * DESKTOP
           *
           * EXISTING FUNCTIONALITY
           * KEPT UNCHANGED
           */
          990: {
            slidesPerView: 6,
            spaceBetween: 8,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0
          }
        }
      });
    }

    /* =========================
       MAIN SLIDER
    ========================= */

    function initMain() {
      mainSwiper = new Swiper(mainEl, {
        slidesPerView: 1.1,
        centeredSlides: false,
        spaceBetween: 10,
        initialSlide: 0,
        speed: 450,
        allowTouchMove: true,
        direction: 'horizontal',
        thumbs: thumbsSwiper
          ? {
              swiper: thumbsSwiper
            }
          : undefined,
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn
        },
        breakpoints: {
          0: {
            slidesPerView: 1.1,
            centeredSlides: false,
            spaceBetween: 10
          },
          990: {
            slidesPerView: 'auto',
            centeredSlides: false,
            spaceBetween: 20
          }
        },
        on: {
          init: function () {
            updateNavigation();
            updateGallery();
          },
          slideChange: function () {
            updateNavigation();
          },
          reachBeginning: function () {
            updateNavigation();
          },
          reachEnd: function () {
            updateNavigation();
          },
          fromEdge: function () {
            updateNavigation();
          }
        }
      });
    }

    /* =========================
       GALLERY UPDATE
    ========================= */

    function updateGallery() {
      if (!mainSwiper) return;

      var mobile = isMobile();

      var direction = mobile
        ? 'ltr'
        : 'rtl';

      /*
       * =========================
       * MAIN SLIDER
       * =========================
       */

      if (
        mainEl.getAttribute('dir') !== direction
      ) {
        mainEl.setAttribute(
          'dir',
          direction
        );
      }

      /*
       * =========================
       * THUMB SLIDER
       * =========================
       */

      if (thumbsEl) {
        if (
          thumbsEl.getAttribute('dir') !== direction
        ) {
          thumbsEl.setAttribute(
            'dir',
            direction
          );
        }
      }

      /*
       * =========================
       * CHANGE SWIPER DIRECTION
       * =========================
       *
       * Only change direction when
       * it is actually required.
       */

      var shouldBeRtl = direction === 'rtl';

      if (
        typeof mainSwiper.rtl !== 'undefined' &&
        mainSwiper.rtl !== shouldBeRtl
      ) {
        mainSwiper.changeLanguageDirection(
          direction
        );
      }

      if (thumbsSwiper) {
        if (
          typeof thumbsSwiper.rtl !== 'undefined' &&
          thumbsSwiper.rtl !== shouldBeRtl
        ) {
          thumbsSwiper.changeLanguageDirection(
            direction
          );
        }
      }

      /*
       * =========================
       * UPDATE DIMENSIONS
       * =========================
       */

      mainSwiper.update();

      if (thumbsSwiper) {
        thumbsSwiper.update();

        /*
         * Make sure Swiper recalculates
         * the thumbnail classes.
         */

        thumbsSwiper.updateSlidesClasses();
      }

      updateNavigation();
    }

    /* =========================
       NAVIGATION
    ========================= */

    function updateNavigation() {
      if (
        !mainSwiper ||
        !prevBtn ||
        !nextBtn
      ) {
        return;
      }

      /*
       * =========================
       * MOBILE
       * =========================
       *
       * Mobile uses LTR:
       *
       * LEFT  = PREVIOUS
       * RIGHT = NEXT
       */

      if (isMobile()) {

        /*
         * PREVIOUS
         */

        if (mainSwiper.isBeginning) {

          prevBtn.classList.add(
            'swiper-button-disabled'
          );

          prevBtn.setAttribute(
            'disabled',
            'disabled'
          );

          prevBtn.setAttribute(
            'aria-disabled',
            'true'
          );

        } else {

          prevBtn.classList.remove(
            'swiper-button-disabled'
          );

          prevBtn.removeAttribute(
            'disabled'
          );

          prevBtn.setAttribute(
            'aria-disabled',
            'false'
          );
        }

        /*
         * NEXT
         */

        if (mainSwiper.isEnd) {

          nextBtn.classList.add(
            'swiper-button-disabled'
          );

          nextBtn.setAttribute(
            'disabled',
            'disabled'
          );

          nextBtn.setAttribute(
            'aria-disabled',
            'true'
          );

        } else {

          nextBtn.classList.remove(
            'swiper-button-disabled'
          );

          nextBtn.removeAttribute(
            'disabled'
          );

          nextBtn.setAttribute(
            'aria-disabled',
            'false'
          );
        }

      } else {

        /*
         * =========================
         * DESKTOP RTL
         * =========================
         *
         * EXISTING FUNCTIONALITY
         * KEPT UNCHANGED
         */

        if (mainSwiper.isBeginning) {

          prevBtn.classList.add(
            'swiper-button-disabled'
          );

        } else {

          prevBtn.classList.remove(
            'swiper-button-disabled'
          );
        }

        if (mainSwiper.isEnd) {

          nextBtn.classList.add(
            'swiper-button-disabled'
          );

        } else {

          nextBtn.classList.remove(
            'swiper-button-disabled'
          );
        }
      }
    }

    /* =========================
       INITIALIZE
    ========================= */

    initThumbs();

    initMain();

    /*
     * Apply direction AFTER both
     * Swipers are initialized.
     */

    updateGallery();

    /* =========================
       RESIZE
    ========================= */

    var resizeTimer;

    window.addEventListener(
      'resize',
      function () {

        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(
          function () {

            if (!mainSwiper) return;

            var oldMobileState =
              mainEl.dataset.mobileState;

            var newMobileState =
              isMobile()
                ? 'mobile'
                : 'desktop';

            /*
             * Only reset position when
             * actually switching between
             * mobile and desktop.
             */

            if (
              oldMobileState &&
              oldMobileState !== newMobileState
            ) {

              mainSwiper.slideTo(
                0,
                0
              );
            }

            mainEl.dataset.mobileState =
              newMobileState;

            updateGallery();

          },
          150
        );
      }
    );

    /*
     * Store initial state.
     */

    mainEl.dataset.mobileState =
      isMobile()
        ? 'mobile'
        : 'desktop';
  }


  /* =========================
     INIT ALL
  ========================= */

  function initAll(scope) {

    (scope || document)
      .querySelectorAll('.box-gallery')
      .forEach(
        initBoxGallery
      );

  }


  /* =========================
     DOM READY
  ========================= */

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      initAll();
    }
  );


  /* =========================
     SHOPIFY SECTION LOAD
  ========================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initAll(
        event.target
      );

    }
  );

})();
